import api from "@/utils/api";
import { appApiEndpoint } from "@/environment";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateSettings = createAsyncThunk(
  "employers/updateSettings",
  async (arg, thunkAPI) => {
    const employerPermalink = arg.employerPermalink;
    const payload = arg.payload;

    const withCredentials = true;
    try {
      const response = await api.put(
        withCredentials,
        `${appApiEndpoint}/v1/employers/${employerPermalink}/settings`,
        {},
        payload
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createImage = createAsyncThunk(
  "employers/createImage",
  async (arg, thunkAPI) => {
    const employerPermalink = arg.employerPermalink;
    const payload = arg.payload;

    const withCredentials = true;
    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/employers/${employerPermalink}/images`,
        {},
        payload
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const keepSessionAlive = createAsyncThunk(
  "employers/keepSessionAlive",
  async (arg, thunkAPI) => {
    const withCredentials = true;
    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/employers/${arg}/session/keep-alive`
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
